// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {validAmountOfUse} from '../../shared/services/claim-shared-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection, pin) =>

    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_BATTERY_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId, pin)(dispatch);

        }

    };

export const updateBatteryClaimPin = pin =>

    dispatch => {

        dispatch({
            property: 'pin',
            type: actions.UPDATE_CLAIM_BATTERY_PROPERTY,
            value: pin
        });

        if (!pin) {

            dispatch({
                property: 'useAmount',
                type: actions.UPDATE_CLAIM_BATTERY_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const updateBatteryClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_BATTERY_PROPERTY,
    value
});

export const updateBatteryClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_BATTERY_WORK_ORDER_ONE,
    workOrder
});

export const updateBatteryClaimWorkOrderTwo = workOrder => ({
    type: actions.UPDATE_CLAIM_BATTERY_WORK_ORDER_TWO,
    workOrder
});

export const updateBatteryClaimApplication = (application, collection) => ({
    application,
    collection,
    type: actions.UPDATE_CLAIM_BATTERY_APPLICATION
});

export const updateBatteryClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_BATTERY_REPAIR_NUMBER
});

export const updateOwnershipStatusDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_BATTERY_OWNERSHIP_STATUS
});

export const updateBatteryClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_BATTERY_FAILURE_PART
});

export const updateBatteryClaimFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_BATTERY_FAILURE_DATE
});

export const updateBatteryClaimRepairDate = repairDate => ({
    repairDate,
    type: actions.UPDATE_CLAIM_BATTERY_REPAIR_DATE
});

export const updateBatteryClaimUnitDropDown = (key, unitCollection) => ({
    key,
    type: actions.UPDATE_CLAIM_BATTERY_USE_AMOUNT_UNIT,
    unitCollection
});

export const updateBatteryClaimUseAmount = (amount, index) => ({
    amount: validAmountOfUse(amount),
    index,
    type: actions.UPDATE_CLAIM_BATTERY_USE_AMOUNT
});

export const updateBatteryClaimInputOnBlur = (property, value, claim) => ({
    property,
    type: actions.UPDATE_CLAIM_BATTERY_FORM_VALIDATION,
    validity: mapFormValidation(property, value, claim)
});

export const resetBatteryClaim = () => ({
    type: actions.RESET_CLAIM_BATTERY
});

export const resetBatteryProductDetails = () => ({
    type: actions.RESET_CLAIM_BATTERY_PRODUCT_DETAILS
});

export const updateInstalledByDropDown = (key, installedByCollection) =>

    dispatch => {

        dispatch({
            installedByCollection,
            key,
            type: actions.UPDATE_CLAIM_BATTERY_INSTALLED_BY
        });

        if (key === 'R') {

            dispatch({
                property: 'pin',
                type: actions.UPDATE_CLAIM_BATTERY_FORM_VALIDATION,
                validity: true
            });

        }

        if (key !== 'R') {

            dispatch({
                property: 'retailInstallDate',
                type: actions.UPDATE_CLAIM_BATTERY_FORM_VALIDATION,
                validity: true
            });

            dispatch({
                property: 'retailInstallDate',
                type: actions.UPDATE_CLAIM_BATTERY_PROPERTY,
                value: null
            });

            dispatch({
                property: 'previousInvoiceNumber',
                type: actions.UPDATE_CLAIM_BATTERY_PROPERTY,
                value: ''
            });

        }

    };

export const resetBatteryPinDetails = () => ({
    type: actions.RESET_CLAIM_BATTERY_PIN_DETAILS
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_BATTERY_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/claim-details.js